import * as React from 'react';

import * as styles from './styles.css';

export interface IStageLayoutProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

export const StageLayout: React.FC<React.PropsWithChildren<IStageLayoutProps>> = ({ children, footer, header }) => {
  return (
    <div className={styles['container']}>
      {header ? <div className={styles['header']}>{header}</div> : null}
      <div className={styles['content']}>{children}</div>
      {footer ? <div className={styles['footer']}>{footer}</div> : null}
    </div>
  );
};
